import { z } from "zod";

export const RegisterSchema = z.object({
    name: z.string().min(1, { message: "Nome é obrigatório!" }),
    lastName: z.string().optional(),
    document: z.string().min(1, { message: "CPF é obrigatório!" }),
    phone: z.string().min(1, { message: "Telefone é obrigatório!" }),
    companyName: z.string().optional(),
   });
